import React from "react";

function Loader() {
  return (
    <div className="wrapper">
      <div className="circleerror">
        <div className="cross">
          {" "}
          <div className="horizontal-line"></div>
          <div className="vertical-line"></div>
        </div>
      </div>
    </div>
  );
}

export default Loader;

// CSS styles
const styles = `
    .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
}

.circleerror {
  position: relative;
  border:2px solid red;
  border-radius: 50%;
  height: 120px;
  width: 120px;
}

.cross {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.horizontal-line, .vertical-line {
  position: absolute;
  background-color: red;
}

.horizontal-line {
  height: 5px;
  left: 20%;
  right: 20%;
  top: 50%;
  transform: rotate(45deg);

}

.vertical-line {
  width: 5px;
  top: 20%;
  bottom: 20%;
  left: 50%;
  transform: rotate(45deg);

}

 
  `;

// Create a style element and append it to the document's head
const styleElement = document.createElement("style");
styleElement.appendChild(document.createTextNode(styles));
document.head.appendChild(styleElement);
